import type { BlogPost } from '@/services/blogService';

/**
 * Gets the appropriate identifier for routing to a blog post detail page.
 * Prefers slug for SEO-friendly URLs, falls back to numeric ID if slug is unavailable.
 *
 * @param post - The blog post object
 * @returns A string identifier suitable for routing (slug or numeric ID)
 */
export function getBlogPostIdentifier(post: BlogPost): string {
  // Always prefer slug for SEO-friendly URLs
  if (post.slug && post.slug.trim()) {
    return post.slug;
  }

  // Fallback to numeric ID if slug is missing or empty
  // This ensures compatibility with the route handler which can process both formats
  return post.id.toString();
}

/**
 * Decodes HTML entities in a string.
 *
 * @param html - HTML string to decode (optional)
 * @returns Decoded string
 */
export function decodeHtmlEntities(html?: string): string {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
}
